import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import _ from 'lodash';
import { appContext } from '../../util/decorators';
import TranslatedLink from '../TranslatedLinkLeague.jsx';
import routeParamMappings from '../../config/routeParamMappings.json';
import sportConfig from '../../config/sports';
import teamsConfig from '../../config/teams';
import leaguesConfig from '../../config/leagues';

const TEAM_IMG_URL = '//ximg.enetscores.com/cdnimg/amalthea/logo/teamlogo';

const mapStateToProps = state => ({
  sports: sportConfig[state.country],
  country: state.country,
});

@connect(mapStateToProps)
@appContext
export default class MegaDropdown extends React.PureComponent {
  render() {
    const t = this.context.app.t;
    const { link: { sublinks }, sports, sport, country } = this.props;

    if (_.isEmpty(sublinks)) return null;

    const mappedSport = routeParamMappings[country][sport];

    if (!sports[mappedSport]) return null;

    const { teams, leagues } = sports[mappedSport];

    if (!teams || !leagues) return null;

    return (
      <div className="navbar-mega-dropdown">
        <div className="highlight-box no-margin">
          <div className="section columns">
            <div className="iconed-list">
              {
                _.map(sublinks, link => {
                  return (
                    <Link key={link.url} to={link.url} className="link">
                      {link.name}
                    </Link>
                  );
                })
              }
            </div>

            <div className="iconed-list">
              <div className="heading">{t('Navbar.popular_leagues')}</div>
              {
                _.map(leagues, id => {
                  const leagueLogo = require(`../../../assets/leagues/logo_${id}.png`);
                  return (
                    <TranslatedLink
                      key={id}
                      routeParams={[sport, leaguesConfig[id][country].slug]}
                      className="link"
                      name="LeaguePage"
                    >
                      <div className="icon">
                        <img src={leagueLogo} />
                      </div>
                      {leaguesConfig[id][country].name}
                    </TranslatedLink>
                  );
                })
              }
            </div>

            <div className="iconed-list">
              <div className="heading">{t('Navbar.popular_teams')}</div>
              {
                _.map(teams, id => {
                  const teamLogo = teamsConfig[id].hasCustomLogo ? require(`../../../assets/teams/${id}.png`) : `${TEAM_IMG_URL}/${id}`;

                  return (
                    <TranslatedLink
                      key={id}
                      routeParams={[sport, teamsConfig[id][country].slug]}
                      className="link" name="TeamPage"
                    >
                      <div className="icon">
                        <img src={teamLogo} />
                      </div>
                      {teamsConfig[id][country].name}
                    </TranslatedLink>
                  );
                })
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

MegaDropdown.propTypes = {
  link: React.PropTypes.object.isRequired,
  sports: React.PropTypes.object,
  sportData: React.PropTypes.object,
  country: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/component/Navigation/MegaDropdown.jsx